/**
 * Copyright (c) 2018 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

export const LANGUAGES = {
  en: 'English',
  ro: 'Română'
};
